module.exports = __webpack_public_path__ + "images/file_icons_v2/pkg-36105596ac9958cbcbda8b356100b478.svg";